import React, { Component } from 'react';
import { Form, Input, Radio } from 'antd';
import { get } from 'lodash';
import DetailTitle from '../../DetailTitle';
import { language } from '../../../language';
import {
    ColorPicker,
    FormItemLayout,
    ConfigFormDecorator,
    NumberInput,
    EffectiveTime,
} from '../../tools';
import './index.less';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

/**
 * 标题组件-配置表单
 */
class TitleDescriptionCom extends Component<any> {
    effectiveTimeChange = (value: any) => {
        const { form, onChange } = this.props;
        const formValue = form.getFieldsValue();
        const { effectiveTime } = value;
        onChange({ ...formValue, effectiveTime });
    };

    render() {
        const {
            form: { getFieldDecorator },
            value,
        } = this.props;
        const formItemLayout = FormItemLayout;
        return (
            <Form className="titleDescription-box">
                <DetailTitle label={`标题设置`} />
                <FormItem {...formItemLayout} label="标题内容">
                    {getFieldDecorator('title', {
                        rules: [
                            {
                                required: true,
                                message: '请输入内容',
                            },
                        ],
                    })(<Input placeholder="输入内容" />)}
                </FormItem>
                <FormItem {...formItemLayout} label="标题颜色">
                    {getFieldDecorator('fontColor')(<ColorPicker defaultColor="#303030" />)}
                </FormItem>
                <FormItem {...formItemLayout} label="标题大小">
                    {getFieldDecorator('fontSize')(<NumberInput min={10} />)}
                </FormItem>
                <FormItem {...formItemLayout} label="标题粗细">
                    {getFieldDecorator('titleWeight')(
                        <RadioGroup className="align-style">
                            <Radio value={'normal'}>常规体</Radio>
                            <Radio value={'bold'}>加粗体</Radio>
                        </RadioGroup>
                    )}
                </FormItem>
                <DetailTitle label={`描述设置`} />
                <FormItem {...formItemLayout} label="描述内容">
                    {getFieldDecorator('describe')(<Input placeholder="输入内容" />)}
                </FormItem>
                <FormItem {...formItemLayout} label="描述颜色">
                    {getFieldDecorator('describeColor')(<ColorPicker defaultColor="#696969" />)}
                </FormItem>
                <FormItem {...formItemLayout} label="描述大小">
                    {getFieldDecorator('describeSize')(<NumberInput min={10} />)}
                </FormItem>
                <FormItem {...formItemLayout} label="描述粗细">
                    {getFieldDecorator('describeWeight')(
                        <RadioGroup className="align-style">
                            <Radio value={'normal'}>常规体</Radio>
                            <Radio value={'bold'}>加粗体</Radio>
                        </RadioGroup>
                    )}
                </FormItem>
                <DetailTitle label={`基础设置`} />
                <FormItem {...formItemLayout} label="对齐方式">
                    {getFieldDecorator('align')(
                        <RadioGroup className="align-style">
                            <Radio value={'left'}>
                                {language.getText('components.Title.left')}
                            </Radio>
                            <Radio value={'center'}>
                                {language.getText('components.Title.center')}
                            </Radio>
                            <Radio value={'right'}>
                                {language.getText('components.Title.right')}
                            </Radio>
                        </RadioGroup>
                    )}
                </FormItem>
                <div style={{ marginBottom: 24 }}>
                    <EffectiveTime
                        value={{ effectiveTime: get(value, 'effectiveTime', null) }}
                        onChange={this.effectiveTimeChange}
                    />
                </div>
            </Form>
        );
    }
}

export const TitleDescription = ConfigFormDecorator(TitleDescriptionCom);
